<template>
	<div v-show="showWindow">
	<div class="dialog draggable-item dialog-resizable light bg-light">
		<div class="dialog-title h6 m-0">
			<span>{{ $t('Command Prompt') }}</span>
			<span class="button square closer" @click="closeCMD"></span>
        </div>


      <div class="dialog-content p-0 m-0" style="height: calc(100% - 20px);">      
		<!--TERMINALE LOGGATO-->
            <form v-if="terminal.isLogged" @submit.prevent="messageToTerminal()" class="d-flex flex-column w-100 h-100">
               <textarea id="textarea" class="bg-black border-visible-none fg-white w-100 p-4"
                  style="font-family: system-ui;height: calc(100% - 75px);font-size: 14px;" readonly
                  v-model.trim="terminal.text" rows="17"></textarea>
               <input name="inputCommand" type="text" class="p-2 w-100 rounded" v-model.trim="terminal.inputCommand" :placeholder="$t('Type a command and press Enter...')">
            </form>

            <form v-else class="form p-5 w-100 h-100 d-flex flex-column flex-align-center text-center" @submit.prevent="loginTerminal">
				<div>
					<img src="/assets/img/icons/prompt.svg" width="50" />
				</div>
				<div class="mt-1">
					<label class="no-wrap">{{ $t("Computer username") }}:</label>
					<input type="text" class="input mt-1" v-model.trim="terminal.username">
				</div>
				<div class="mt-4">
					<label>{{ $t("Computer password") }}:</label>
					<input class="input mt-1" type="password" v-model.trim="terminal.password" :placeholder="$t('Password')" />
					<span class="invalid_feedback">{{ $t('Please enter a valid password') }}</span>
				</div>
				<div class="w-100 mt-4">
					<input :disabled="terminal.password == '' || terminal.username == ''" type="submit" class="button secondary w-25" :value="$t('Login')">
				</div>
            </form>
         </div>
      </div>
	  </div>
</template>

<script>
import { draggableMixin } from '../../mixins/draggable-mixin';

export default {
	name: "Terminal",
	mixins: [draggableMixin],

	created() {
		this.$root.$on("openCMD", this.openCMD);
		this.$root.$on("closeCMD", this.closeCMD);
		this.$root.$on("runCMD", cmdResponseText => this.setCMDResponse(cmdResponseText));
	},
	beforeDestroy() {
		this.$root.$off("openCMD", this.openCMD);
		this.$root.$off("closeCMD", this.closeCMD);
	},
	data() {
		return {
			showWindow: false, // (1) parte chiusa

			win: null,
			terminal: {
				//toggleTerminal: false,
				text: "",
				isLogged: false,
				inputCommand: "",
				username: "Administrator",
				password: ""

			},
		}
	},
	methods: {
		/*openCMD() {

			//this.terminal.toggleTerminal=true;
			//Metro.window.show("#terminalwindow");
			if ($(".window")[0].hasClass("d-none")) {
				$(".window").removeClass("d-none");
			}
		},
		closeCMD() {
			this.terminal.text="";
			this.terminal.inputCommand="";
			var content=document.getElementById('textarea');
			content.scrollTop=content.scrollHeight;
			this.terminal.isLogged=false;
			//this.terminal.toggleTerminal=false;
			if (!$(".window")[0].hasClass("d-none")) {
				$(".window").addClass("d-none");
			}
		},*/
		_getWindowEl() {
			// punto di verità: l’elemento .window generato da Metro intorno al tuo ref
			return $(this.$refs.win).closest('.window');
		},
		openCMD() { this.showWindow=true; },

		closeCMD() {
			// reset stato
			this.terminal.terminalText="";
			this.terminal.terminalInput="";
			this.terminal.terminalLogged=false;
			this.showWindow=false;
		},

		setCMDResponse(cmdResponseText){
			this.terminal.text+="\n"+cmdResponseText;
			this.terminal.inputCommand="";
			var content=document.getElementById('textarea');
			content.scrollTop=content.scrollHeight;
		},
		
		loginTerminal() {
			var self=this;
			this.$root.socket("startcmd", self.terminal.username, self.terminal.password)
				.then(response => {
					if (response!="") {
						self.terminal.isLogged=true;
						self.terminal.text+=response.text;
					}
				});
		},

		messageToTerminal() {
			var self=this;
			self.terminal.text+=self.terminal.inputCommand;
			this.$root.socket("runcmd", self.terminal.inputCommand);
			//self.terminal.text += self.terminal.inputCommand;
			self.inputCommand="";
		},

	}
}
</script>